export default {"src":"/_next/static/media/philips.936bd39d.svg","height":149,"width":158,"blurWidth":0,"blurHeight":0};